
import "../css/header.css";

import image1 from "../img/utpl.png";

function Header() {
  return (
    <>
      <div className="wrapper-header">
        <div className="layout8">
          <div className="logo ">
            <div>
              <a href="https://utpl.edu.ec">
                <img src={image1} alt="utpl"></img>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
